// Form editor types enumeration
export const FORM_EDITOR_TYPE_MAP = Object.freeze({
  DEFAULT: "default",
  FORM: "form",
  CHECK: "check",
  PACKAGE: "package",
  BLOCK: "block",
})

// User roles enumeration
export const ROLES_MAP = Object.freeze({
  ANALYST: 'Analyst',
  SUBJECT: 'Subject',
  CLIENT: 'Client',
  REFEREE: 'Referee',
})

// Column identifiers for form editor features
export const COLUMNS_MAP = Object.freeze({
  BLOCK_VISIBILITY: "block_visibility",
  CASE_CREATION: "use_in_case_creation",
  REPORT_VISIBILITY: "report_visibility",
  BATCH_PROCESSING: "use_in_batch_processing",
})

/**
 * Role display configuration - optimized flat structure
 * Maps each role directly to its display configuration
 * Structure: role_name -> {allowed: [editor_types], restricted: [editor_types]}
 */
export const FORM_EDITOR_ROLE_DISPLAY_MAP = Object.freeze({
  [ROLES_MAP.ANALYST]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [ROLES_MAP.SUBJECT]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [ROLES_MAP.CLIENT]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [ROLES_MAP.REFEREE]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
});

/**
 * Column display configuration - optimized flat structure
 * Maps each column directly to its display configuration
 * Structure: column_name -> {allowed: [editor_types], restricted: [editor_types]}
 */
export const FORM_EDITOR_COLUMN_DISPLAY_MAP = Object.freeze({
  [COLUMNS_MAP.BLOCK_VISIBILITY]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [COLUMNS_MAP.CASE_CREATION]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [COLUMNS_MAP.REPORT_VISIBILITY]: {
    allowed: [FORM_EDITOR_TYPE_MAP.DEFAULT],
    restricted: []
  },
  [COLUMNS_MAP.BATCH_PROCESSING]: {
    allowed: [
      FORM_EDITOR_TYPE_MAP.DEFAULT,
    ],
    restricted: [
      FORM_EDITOR_TYPE_MAP.BLOCK,
    ]
  },
});

/**
 * Main header display configuration object
 * Aggregates role and column display maps for easy access
 * Used by getHeaderDisplay function to determine visibility of UI elements
 * based on form editor type and header type (roles/columns)
 */
export const FORM_EDITOR_HEADER_DISPLAY = Object.freeze({
  roles: FORM_EDITOR_ROLE_DISPLAY_MAP,
  columns: FORM_EDITOR_COLUMN_DISPLAY_MAP,
})


// Header sizes
export const ROLE_HEADER_WIDTH = "132px";
export const COLUMN_HEADER_WIDTH = "100px";
export const DROPDOWN_HEADER_WIDTH = "220px";
export const HEADER_PADDING_X_CLASS = "px-3";
export const FIELD_ITEM_GAP_CLASS = "gap-3";
export const FIELD_ITEM_AFTER_PLACEHOLDER = "50px";

// Header style objects
export const roleHeaderStyles = Object.freeze({
  width: ROLE_HEADER_WIDTH,
})
export const columnHeaderStyles = Object.freeze({
  width: COLUMN_HEADER_WIDTH,
})
export const dropdownHeaderStyles = Object.freeze({
  width: DROPDOWN_HEADER_WIDTH,
})
export const afterPlaceholderStyles = Object.freeze({
  width: FIELD_ITEM_AFTER_PLACEHOLDER,
})

export const EXCLUDES = Object.freeze({
  blockFields: [COLUMNS_MAP.BATCH_PROCESSING],
});